<template>
    <v-app>
        <header-card-public current_page="support"></header-card-public>
         <v-content class="bg">
            <v-layout fill-height align-center row wrap>
                <v-flex xs12 sm12>
                    <v-card class="mt-3 mx-auto" max-width="800">
                        <v-toolbar flat height="45px">
                            <h3>Contact Us</h3>
                        </v-toolbar>
                        <v-card-text class="text-xs-left">
                            <div style="margin:0px 10px 10px 10px;">
                                <p>We value your feedback, inquiries, and suggestions. Please feel free to reach out to us using the following contact information:</p>
                                <b>Customer Support</b>
                                <p>If you have any questions, concerns, or need assistance, our dedicated customer support team is here to help. You can reach us by email during our business hours.</p>
                                <ul>
                                    <li>Email: support@sweldonow.ph</li>
                                </ul><br>
                                <b>Billing Inquiries</b>
                                <p>For any questions or issues related to billing, invoices, or payment methods, please contact our billing department:</p>
                                <ul>
                                    <li>Email: billing@sweldonow.ph</li>
                                </ul><br>
                                <b>Sales and Affiliate Partnership</b>
                                <p>For business-related inquiries, such as sales or becoming an affiliate partner, please get in touch with our sales team. We're excited to explore new opportunities with you:</p>
                                <ul>
                                    <li>Email: sales@sweldonow.ph</li>
                                </ul>
                            </div>
                        </v-card-text>
                    </v-card>   
                </v-flex>
            </v-layout>
         </v-content>
    </v-app>
</template>
<script>

import '@/assets/css/public.css'
import '@/assets/css/season.css'

export default {
    name: 'Support',
    metaInfo: {
        title: 'Support',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Read FAQ, Pricing, Knowledge Hub or email us at support@sweldonow.ph' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'header-card-public': () => import('@/components/Common/HeaderPublic')
    },
    data () {
        return {
            error: false,
            errorMessage: null,
            drawer: false,
            icons: [
                {icon: 'fab fa-facebook', link: 'https://www.facebook.com/Accureos-101753728463338', title: 'Accureos Facebook page'},
                {icon: 'fab fa-youtube', link: 'https://www.youtube.com/channel/UCSlaGhEXs2hMiWthvmOzWAg', title: 'Accureos Youtube channel'},
            ]
        }
    },   
    methods: {
        OpenWindow(url) {
            if (url!='') window.open(url, '_blank')
        }  
    },
    computed: {
        contentMargin() {
            return this.isMobile? "margin:100px 20px 20px 20px" : "margin:150px 200px 0px 200px"
        }
    },
    created() {}
  }
</script>